/**
 * Type for realtime handler function
 */
export type RealtimeHandlerFunction = (data: any, sender: string) => void | Promise<void>;

/**
 * Map of channel:action -> handler function
 */
export type RealtimeHandlerMap = Map<string, RealtimeHandlerFunction>;

/**
 * Helper to create handler map key
 * @param eventName - The event name from msg.name ("Student", "Whiteboard", etc.)
 * @param action - The action from payload.Action ("RaisingHand", "ObjectAdded", etc.)
 * @returns Combined key for handler routing (e.g., "Student:RaisingHand")
 */
export function createRealtimeHandlerKey(eventName: string, action: string): string {
  return `${eventName}:${action}`;
}
